import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { updateTransactionEightyG, updateTransactionTenbe, getTransactionHistory } from "../../api/services/formService";

export const fetchTransactionHistory = createAsyncThunk(
  "transaction/fetchTransactionHistory",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await getTransactionHistory(userId);
      return response.data || response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch transaction history');
    }
  }
);

export const downloadEightyGCertificate = createAsyncThunk(
  "transaction/downloadEightyGCertificate",
  async (transactionId, { rejectWithValue }) => {
    try {
      const response = await updateTransactionEightyG(transactionId);
      return response.data || response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to update 80G certificate status');
    }
  }
);

export const downloadTenbeCertificate = createAsyncThunk(
  "transaction/downloadTenbeCertificate",
  async ({ pan, financialYear }, { rejectWithValue }) => {
    try {
      const response = await updateTransactionTenbe(pan, financialYear);
      return response.data || response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to update 10B certificate status');
    }
  }
);

const transactionSlice = createSlice({
  name: "transaction",
  initialState: {
    transactionHistory: null,
    loading: false,
    error: null,
    success: null
  },
  reducers: {
    clearTransactionData: (state) => {
      state.error = null;
      state.success = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Transaction History
      .addCase(fetchTransactionHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransactionHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.transactionHistory = action.payload;
      })
      .addCase(fetchTransactionHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      // Download 80G Certificate
      .addCase(downloadEightyGCertificate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadEightyGCertificate.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload;
      })
      .addCase(downloadEightyGCertificate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Download 10B Certificate
      .addCase(downloadTenbeCertificate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadTenbeCertificate.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload;
      })
      .addCase(downloadTenbeCertificate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearTransactionData } = transactionSlice.actions;
export default transactionSlice.reducer;

